import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { GridColConfig, CustomgridOptions } from 'src/app/core/custom-grid/custom-grid';
import { CustomGridComponent } from 'src/app/core/custom-grid/custom-grid.component';
import { CustomOverLayDialogOptions } from 'src/app/core/custom-overlay-dialog/custom-overlay-dialog';
import { CustomOverlayDialogComponent } from 'src/app/core/custom-overlay-dialog/custom-overlay-dialog.component';
import { CustomOverlayMessaggeOptions } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge';
import { CustomOverlayMessaggeComponent } from 'src/app/core/custom-overlay-messagge/custom-overlay-messagge.component';
import { ToastService } from 'src/app/core/toast/toast.service';
import { BaseCodiceIdResposnse } from 'src/app/model/response/base-response';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { HubService } from 'src/app/services/web-socket/hub.service';
import { environment } from 'src/environments/environment';
import { ClientDto } from './clienti';
import { CustomGridModule } from "src/app/core/custom-grid/custom-grid.module";
import { CustomOverlayMessaggeModule } from "src/app/core/custom-overlay-messagge/custom-overlay-messagge.module";

@Component({
  selector: 'app-clienti',
  imports: [CustomGridModule, CustomOverlayMessaggeModule],
  templateUrl: './clienti.component.html',
  styleUrl: './clienti.component.scss'
})
export class ClientiComponent implements OnInit, OnDestroy {
  @ViewChild(CustomGridComponent) Cgrid: CustomGridComponent | undefined;

  options: GridColConfig[] = [];
  @ViewChild(CustomOverlayMessaggeComponent) overlayMessagge: CustomOverlayMessaggeComponent | undefined;


  gridOptions: CustomgridOptions = {
    apiCallurl: '/api/clients',
    rowsCallurl: '',
    apiTableName: 'Clienti',
    notLazy: true
  };

  dialogMessaggeOptions: CustomOverlayMessaggeOptions = {
    dialogTitle: "Stai per eliminare il cliente, procedere?",
    deleteDialogOptions: {
      deleteEntityName: 'Cliente',
      deleteUrl: `${environment.apiUrl}/clients`,
      isFem: false,
    }
  };


  private theEnd$ = new Subject<void>();


  constructor(
    private localstorage: LocalStorageService,
    private router: Router  ) {
  }



  ngOnInit(): void { //TODO make lazy loading


    this.localstorage.setTitolo('Clienti');


        this.options = [
          {
            type: 'button',
            name: 'Modifica',
            field: 'none',
            icon: 'pencil',
            cssClass: 'edit-button',
            fieldOptions: {
            },
            width: '40'
          },
          {
            type: 'text',
            name: 'Nome',
            field: 'name',
            fieldOptions: {
            }
          },
          {
            type: 'text',
            name: 'Descrizione',
            field: 'description',
            fieldOptions: {
            }
          },
          {
            type: 'button',
            name: 'Elimina',
            field: 'none',
            icon: 'trash',
            cssClass: 'delete-button',
            fieldOptions: {
            },
            width: '40'
          }
        ];
  }

  ngOnDestroy(): void {
    this.theEnd$.next();
    this.theEnd$.complete();
  }


  btnClick(event: any) {
    if (event.action == 'modifica') {
      this.edit(event.data.id)
    }
    if (event.action == 'elimina') {
  
      this.overlayMessagge?.showDialog();
      this.overlayMessagge!.deleteItem = event.data.id;
    }

  }

  edit(id: string): void {
    this.router.navigate([`/home/clienti/${id}`]);
  }

  
  add(): void {
    this.router.navigate([`/home/clienti/new`]);
  }

  dialogClosed() {
    this.Cgrid?.refreshTable();
  }

}
